import { render, staticRenderFns } from "./LayCenter.vue?vue&type=template&id=1d796421&scoped=true&"
import script from "./LayCenter.vue?vue&type=script&lang=js&"
export * from "./LayCenter.vue?vue&type=script&lang=js&"
import style0 from "./LayCenter.vue?vue&type=style&index=0&id=1d796421&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d796421",
  null
  
)

export default component.exports